import { SiteSecurity } from "src/types/responses/site";
import securityApi from "../clients/security-api";

class SecurityAdminsSitesApi {
  async fetchAvailableSecurityAdminsSites(): Promise<SiteSecurity[]> {
    const { data } = await securityApi.get<SiteSecurity[]>("/sites");

    return data;
  }

  async fetchResourcesLevels(): Promise<number[]> {
    const { data } = await securityApi.get<number[]>("/sites/spot-levels");

    return data;
  }

  async fetchTenants(): Promise<any> {
    const { data } = await securityApi.get<any>("/sites/tenants");

    return data;
  }
}

export const securityAdminsSitesApi = new SecurityAdminsSitesApi();
